// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3i8pd","productName":"Table_productName__11j3Y"};